import { render, staticRenderFns } from "./urgent-ship-in.vue?vue&type=template&id=1ea4f344&scoped=true"
import script from "./urgent-ship-in.vue?vue&type=script&lang=js"
export * from "./urgent-ship-in.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea4f344",
  null
  
)

export default component.exports